/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} News_LeadInputs */



/**
* | output |
* | --- |
* | "Regulatory changes, safety alerts and guidance that matter on board, picked by our team." |
*
* @param {News_LeadInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
export const news_lead = /** @type {((inputs?: News_LeadInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<News_LeadInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return /** @type {LocalizedString} */ ("由我们团队精选的、与船上工作息息相关的法规变化、安全警示和指南。")
	return /** @type {LocalizedString} */ ("Regulatory changes, safety alerts and guidance that matter on board, picked by our team.")
});